<template>
  <div class="ms-container">
    <resources-page />
  </div>
</template>

<script>
import ResourcesPage from '@/components/resources/resources-page'

export default {
  components: {
    ResourcesPage
  }
}
</script>

<style></style>
